import { MessageGroupComponents } from "@hex-insights/verita-romania.shared";
import { messagingCreatePageInfo } from "../../CreatePage/pageinfo";
import { messagingMessageGroupPageInfo } from "../../MessageGroup/pageinfo";
import { NewMessageModal } from "../NewMessageModal";

export type MessageGroupsListProps = Omit<
	MessageGroupComponents.MessageGroupsListProps,
	"createPageInfo" | "NewMessageModal" | "messageGroupPageTo"
>;

export function MessageGroupsList(props: MessageGroupsListProps) {
	return (
		<MessageGroupComponents.MessageGroupsList
			{...props}
			createPageInfo={messagingCreatePageInfo}
			NewMessageModal={NewMessageModal}
			messageGroupPageTo={messagingMessageGroupPageInfo.to}
		/>
	);
}
